/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './CardPromotional.scss';
import { appCardStyle, getKeyByValue, appIconsPath } from '@utils/globalConstant';
import PropTypes from 'prop-types';
import Icons from '@core/Utils/Icons/Icons';
import { sanitizeRichText } from '@utils/sanitizeHtml';
export function CardPromotional({
  cardStyle = appCardStyle.DEFAULT,
  cardIcon = null,
  cardTitle = '',
  text = ''
}) {
    const cardPromotionalIcon = getKeyByValue(appIconsPath,cardIcon);
  return (
    <div className={`${cardStyle} p-16 rounded`}>
      <div className="d-flex justify-content-between gap-16">
        <Icons name={cardPromotionalIcon} height={40} alt="card-icon" colorType='dark' />
        <div className="pe-40">
          <div className="ek-copy-sm-14-semibold" dangerouslySetInnerHTML={{ __html: sanitizeRichText(cardTitle) }} />
          <div className="ek-labeltext-12-medium" dangerouslySetInnerHTML={{ __html: sanitizeRichText(text) }} />
        </div>
      </div>
    </div>
  );
}

CardPromotional.propTypes = {
  cardStyle: PropTypes.string,
  cardIcon: PropTypes.string.isRequired,
  cardTitle: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default CardPromotional;
